import { updateFeedbackText, type UpdateRemoteFeedback } from "./updateFeedbackPresentation";
import { getI18n, useTranslation } from "react-i18next";
import source from "./locales/en/updates";
export type UpdatesKey = Exclude<keyof typeof source, `${string}_one` | `${string}_other`> | "releases";
export type UpdatesValues = Record<string, string | number>;
export type UpdatesMessage = { key: UpdatesKey; values?: UpdatesValues };
export type UpdatesFailure = string | UpdatesMessage | UpdateRemoteFeedback;
export function useUpdatesLanguage(): void { useTranslation("updates"); }
export function updatesLocale(): string { return getI18n()?.resolvedLanguage ?? getI18n()?.language ?? "en"; }
export function updatesNumber(value: number): string { return new Intl.NumberFormat(updatesLocale()).format(value); }
export function updatesText(key: UpdatesKey, values?: UpdatesValues): string {
  if (typeof values?.count === "number") values = { ...values, displayCount: updatesNumber(values.count) };
  const engine = getI18n();
  if (engine?.isInitialized) return engine.getFixedT(null, "updates")(($): string => ($ as Record<string, string>)[key], values);
  const messages: Record<string, string> = source;
  const value = messages[key] ?? messages[`${key}_${values?.count === 1 ? "one" : "other"}`] ?? key;
  return value.replace(/{{(\w+)}}/g, (_, name: string) => String(values?.[name] ?? `{{${name}}}`));
}
export function updatesFailureText(value: UpdatesFailure | null): string | null {
  return value === null ? null : typeof value === "string" ? value : "remote" in value ? updateFeedbackText(value) : updatesText(value.key, value.values);
}
